import { FETCH_TRANSACTION, ADD_TRANSACTION, EDIT_TRANSACTION, DESTROY_TRANSACTION } from '../actionTypes';

export const addTransaction = transaction => ({
    type: ADD_TRANSACTION,
    transaction
});

export const fetchTransaction = transactions => ({
    type: FETCH_TRANSACTION,
    transactions
});

export const editTransaction = transaction => ({
    type: EDIT_TRANSACTION,
    transaction
});

export const destroyTransaction = key => ({
    type: DESTROY_TRANSACTION,
    key
});